import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { Section1Component } from './section1/section1.component';
import { Section2Component } from './section2/section2.component';
import {AppRoutingModule} from './app-routing.module';
import { VideoPlayerComponent } from './video-player/video-player.component';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { StartComponentComponent } from './start-component/start-component.component';
import {GoogleMapsModule} from '@angular/google-maps';
import { ScannerComponent } from './scanner/scanner.component';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import { EndComponent } from './end/end.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {JwSocialButtonsModule} from 'jw-angular-social-buttons';
@NgModule({
  declarations: [
    AppComponent,
    Section1Component,
    Section2Component,
    VideoPlayerComponent,
    StartComponentComponent,
    ScannerComponent,
    EndComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    GoogleMapsModule,
    ZXingScannerModule,
    FontAwesomeModule,
    DragDropModule,
    CommonModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
